import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
import moment, { Moment } from 'moment'

import DatePicker from 'common/components/dataEntry/components/DatePicker'
import Input from 'common/components/dataEntry/components/Input'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

interface searchFieldsProps {
  isSearchButtonLoading?: boolean
  isDownloadButtonLoading?: boolean
  onSearch?: (value: any) => void
  onDownload?: (value: any) => void
}

const SearchFields: React.FC<searchFieldsProps> = ({
  onSearch,
  onDownload,
  isSearchButtonLoading,
  isDownloadButtonLoading,
}) => {
  const { t: translate } = useTranslation()
  const [company, setCompany] = useState<string>()
  const [docReviewer, setDocReviewer] = useState<string>()
  const [employee, setEmployee] = useState<string>()
  const [startDate, setStartDate] = useState<string>()
  const [endDate, setEndDate] = useState<string>()

  const searchCompany = (e: any) => {
    const value = e.target.value
    setCompany(value)
    if (e.keyCode == 13) {
      onSearchClick()
    }
  }

  const searchReviewer = (e: any) => {
    const value = e.target.value
    setDocReviewer(value)
    if (e.keyCode == 13) {
      onSearchClick()
    }
  }

  const searchEmployee = (e: any) => {
    const value = e.target.value
    setEmployee(value)
    if (e.keyCode == 13) {
      onSearchClick()
    }
  }

  const onStartDateChange = (date: Moment | null, dateString: string) => {
    setStartDate(dateString)
  }

  const onEndDateChange = (date: Moment | null, dateString: string) => {
    setEndDate(dateString)
  }

  const onSearchClick = () => {
    const searchReq = {
      company: company,
      docReviewer: docReviewer,
      employee: employee,
      startDate: startDate,
      endDate: endDate,
    }

    onSearch(searchReq)
  }

  const onDownloadClick = () => {
    const searchReq = {
      company: company,
      docReviewer: docReviewer,
      employee: employee,
      startDate: startDate,
      endDate: endDate,
    }

    onDownload(searchReq)
  }

  return (
    <div>
      <Row className="mt-16">
        <Col span={8}>
          <p className="mb-8">{translate('csi-dashboard.audit-search.company')}</p>
          <div className="flex flex__space_between">
            <Input suffix={searchIcon} onKeyUp={searchCompany} className="mr-8"></Input>
          </div>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <p className="mb-8">{translate('csi-dashboard.audit-search.reviewer')}</p>
          <div className="flex flex__space_between">
            <Input suffix={searchIcon} onKeyUp={searchReviewer} className="mr-8"></Input>
          </div>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col span={8}>
          <p className="mb-8">{translate('csi-dashboard.audit-search.employee-name')}</p>
          <div className="flex flex__space_between">
            <Input suffix={searchIcon} onKeyUp={searchEmployee} className="mr-8"></Input>
          </div>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <p className="mb-8">{translate('csi-dashboard.audit-search.date-range')}</p>
          <div className="flex flex__start">
            <DatePicker
              placeholder="Start Date"
              name="startDate"
              className="mr-8"
              format={'MM/DD/YYYY'}
              onChange={onStartDateChange}
              disabledDate={(d) => !d || d.isAfter(moment().add(0, 'day'))}
            ></DatePicker>
            <DatePicker
              placeholder="End Date"
              name="endDate"
              className="ml-8"
              format={'MM/DD/YYYY'}
              onChange={onEndDateChange}
              disabledDate={(d) => !d || d.isAfter(moment().add(0, 'day'))}
            ></DatePicker>
          </div>
        </Col>
      </Row>
      <Row className="mt-16">
        <Col span={8}>
          <Button
            type="primary"
            onClick={onSearchClick}
            loading={isSearchButtonLoading}
            disabled={isSearchButtonLoading}
          >
            {translate('general.search')}
          </Button>
          <Button
            type="default"
            className="ml-16"
            onClick={onDownloadClick}
            loading={isDownloadButtonLoading}
            disabled={isDownloadButtonLoading}
          >
            {translate('csi-dashboard.audit-search.download-csv')}
          </Button>
        </Col>
      </Row>
    </div>
  )
}

const searchIcon = <Icon type="fal fa-search" fontAwesome />

export default SearchFields
